export default function (Component) {
Component.options.__tip = "<p><code>FdCombobox</code> supports <code>v-model</code> and thus you can easily create bi-directional bindings.</p>\n"
}